import React, { useState } from 'react';
import { PageContainer, PageHeader } from '@/components/layout';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Spinner } from '@/components/ui/spinner';
import { adminKakaoMemoApi } from '@/api/adminKakaoMemoApi';

/**
 * 카카오톡 "나에게 보내기" 관리자 알림(신규가입/입금요청/입금완료) 최초 연동·재연동 페이지.
 * 최초 설정 시, 그리고 refresh_token 만료로 Slack 재인증 알림이 왔을 때 이 페이지에서
 * 다시 연동하면 된다. 사이드 메뉴에는 등록하지 않고 직접 URL로 접근한다(일회성 설정
 * 작업이라 상시 메뉴 노출은 과함).
 */
export default function KakaoMemoAdminPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleStart = async () => {
    setLoading(true);
    setError(null);
    try {
      const authorizeUrl = await adminKakaoMemoApi.getAuthorizeUrl();
      window.location.href = authorizeUrl;
    } catch (err: any) {
      setError(err.response?.data?.message || '인가 URL 발급에 실패했습니다.');
      setLoading(false);
    }
  };

  return (
    <PageContainer maxWidth="full">
      <PageHeader
        title="카카오톡 관리자 알림 연동"
        description="신규 회원가입 / 계좌이체 입금요청 / 입금확인 이벤트를 관리자 본인 카카오톡(나와의 채팅)으로 받습니다."
      />

      <Card className="mt-4">
        <CardHeader>
          <CardTitle>연동 시작</CardTitle>
          <CardDescription>
            버튼을 누르면 카카오 로그인/동의 화면으로 이동합니다. 동의를 완료하면 이 창이 다시
            돌아와 연동 완료 메시지를 보여줍니다.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {error && (
            <Alert variant="destructive">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          <Button onClick={handleStart} disabled={loading}>
            {loading ? <Spinner size="sm" className="mr-2" /> : null}
            카카오톡 연동 시작
          </Button>

          <p className="text-sm text-gray-500">
            이미 연동돼 있다면 다시 눌러도 안전합니다(토큰이 갱신됩니다). refresh token
            만료로 Slack에서 재인증 알림을 받았을 때도 이 버튼을 다시 눌러주세요.
          </p>
        </CardContent>
      </Card>
    </PageContainer>
  );
}
